import { createAsyncThunk } from '@reduxjs/toolkit';
import { NAV_BOOKMARKED_ITEMS_ATTR } from '../../constants/navPersona';
import { navPersonaService } from '../../services';
import { NAV_ITEM_BOOKMARKS_GROUP_ID } from '../../constants/Bookmarks';
import { updateNavItemBookmarkState } from '../../reducers/navItems';
export const bookmarksToPersonaApiAction = createAsyncThunk('navItems/to-persona-api', async (__, {
  getState
}) => {
  const {
    navItems,
    user
  } = getState();
  const ids = [];
  const entities = {};
  for (const bookmark of navItems.byId[NAV_ITEM_BOOKMARKS_GROUP_ID].children) {
    var _navItems$byId$bookma;
    ids.push(bookmark.id);
    entities[bookmark.id] = {
      id: bookmark.id,
      path: ((_navItems$byId$bookma = navItems.byId[bookmark.id]) === null || _navItems$byId$bookma === void 0 ? void 0 : _navItems$byId$bookma.path) || ''
    };
  }
  const serializedBookmarksState = JSON.stringify({
    ids,
    entities
  });
  return await navPersonaService.setAttribute(NAV_BOOKMARKED_ITEMS_ATTR, serializedBookmarksState, user.id);
});
export const addBookmark = createAsyncThunk('bookmarks/add', async ({
  navItemId
}, {
  getState: __getState,
  dispatch,
  rejectWithValue
}) => {
  try {
    // Update local state optimistically
    dispatch(updateNavItemBookmarkState({
      id: navItemId,
      isBookmarked: true
    }));

    // Persist to backend
    const response = await dispatch(bookmarksToPersonaApiAction());
    if (response.payload == null) {
      // Revert optimistic update on failure
      dispatch(updateNavItemBookmarkState({
        id: navItemId,
        isBookmarked: false
      }));
      return rejectWithValue('Failed to add bookmark');
    }
    return true;
  } catch (error) {
    // Revert optimistic update on error
    dispatch(updateNavItemBookmarkState({
      id: navItemId,
      isBookmarked: false
    }));
    return rejectWithValue(error);
  }
}, {
  condition: ({
    navItemId
  }, {
    getState
  }) => {
    const state = getState();
    const navItem = state.navItems.byId[navItemId];
    // Don't add if already bookmarked or nav item doesn't exist
    return navItem && !navItem.isBookmarked;
  }
});
export const removeBookmark = createAsyncThunk('bookmarks/remove', async ({
  navItemId
}, {
  getState: __getState,
  dispatch,
  rejectWithValue
}) => {
  try {
    // Update local state optimistically
    dispatch(updateNavItemBookmarkState({
      id: navItemId,
      isBookmarked: false
    }));

    // Persist to backend
    const response = await dispatch(bookmarksToPersonaApiAction());
    if (response.payload == null) {
      // Revert optimistic update on failure
      dispatch(updateNavItemBookmarkState({
        id: navItemId,
        isBookmarked: true
      }));
      return rejectWithValue('Failed to remove bookmark');
    }
    return true;
  } catch (error) {
    // Revert optimistic update on error
    dispatch(updateNavItemBookmarkState({
      id: navItemId,
      isBookmarked: true
    }));
    return rejectWithValue(error);
  }
}, {
  condition: ({
    navItemId
  }, {
    getState
  }) => {
    var _bookmarksGroup$child;
    const state = getState();
    const navItem = state.navItems.byId[navItemId];
    const bookmarksGroup = state.navItems.byId[NAV_ITEM_BOOKMARKS_GROUP_ID];
    const isCurrentlyBookmarked = (bookmarksGroup === null || bookmarksGroup === void 0 || (_bookmarksGroup$child = bookmarksGroup.children) === null || _bookmarksGroup$child === void 0 ? void 0 : _bookmarksGroup$child.some(child => child.id === navItemId)) || false;
    // Don't remove if not bookmarked or nav item doesn't exist
    return navItem && isCurrentlyBookmarked;
  }
});